// Anonymous message section + answers the team has published.

export const anonymousContent = {
  title: "Send Us An Anonymous Message",
  desc: "Afraid to ask openly? Share your question or concern without giving your name. Our team will read every message with care and confidentiality.",
  modes: [
    {
      id: "anonymous",
      icon: "icon-user",
      title: "Stay Anonymous",
      desc: "Send without any personal details. We cannot reply to you directly — check the answers below.",
    },
    {
      id: "contact",
      icon: "icon-phone",
      title: "Let Us Contact You",
      desc: "Leave your phone or email and our team will contact you in confidence.",
    },
  ],
  topics: [
    "Addiction help",
    "Mental health support",
    "Family / guardian concern",
    "Treatment & admission",
    "Feedback / suggestion",
    "Other",
  ],
  privacyNote:
    "Your contact details are used only by our clinical team to reply. They are never shared.",
  modeTitle: "How would you like us to handle your message?",
  topicPlaceholder: "Select a topic",
  answersTitle: "Our Answers To Anonymous Questions",
  answersDesc: "If you sent us a question, you may find our answer here.",
};

// Answers to common anonymous questions (published by the team). `pinned` items appear first.
export const publicResponses = [
  {
    id: 1,
    pinned: true,
    topic: "Treatment & admission",
    question: "My brother uses Yaba but refuses treatment. What can we do?",
    answer:
      "This is very common. Avoid arguments and blame; choose a calm moment to talk. A family counseling session with our team can help you plan how to approach him. In some cases our team can guide safe admission with the family's involvement.",
    by: "Addiction Counseling Team",
    date: "2026-09-20",
  },
  {
    id: 2,
    pinned: false,
    topic: "Mental health support",
    question:
      "Is it normal to feel sad and tired for weeks without any reason?",
    answer:
      "Feeling low for more than two weeks, especially with poor sleep, tiredness or loss of interest, can be a sign of depression. Depression is a medical condition and it is treatable. Please take our free depression check and consider a consultation.",
    by: "Psychiatry Department",
    date: "2026-09-12",
  },
  {
    id: 3,
    pinned: false,
    topic: "Family / guardian concern",
    question: "Will my family member's treatment be kept confidential?",
    answer:
      "Yes. Treatment information is shared only with the clinical team caring for the patient and with family members the patient (or legal guardian) agrees to. Your privacy is protected.",
    by: "Unity Health Centre",
    date: "2026-08-30",
  },
];
